import React from 'react';
import { ATSReport } from '@/api/types';

interface KeywordsTabProps {
  report: ATSReport;
}

export function AnalysisKeywordsTab({ report }: KeywordsTabProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div>
        <h3 className="text-xs font-semibold uppercase tracking-wider mb-4 text-slate-600 dark:text-slate-400">Matched Keywords ({report.matchedKeywords.length})</h3>
        {report.matchedKeywords.length === 0 ? (
          <p className="text-sm text-slate-600 dark:text-slate-400">None</p>
        ) : (
          <div className="flex flex-wrap gap-2">
            {report.matchedKeywords.map((kw, i) => (
              <span key={i} className="px-2 py-1 bg-emerald-50 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-500/20 text-xs font-semibold uppercase tracking-wider rounded">
                {kw}
              </span>
            ))}
          </div>
        )}
      </div>
      <div>
        <h3 className="text-xs font-semibold uppercase tracking-wider mb-4 text-slate-600 dark:text-slate-400">Missing Keywords ({report.missingKeywords.length})</h3>
        {report.missingKeywords.length === 0 ? (
          <p className="text-sm text-slate-600 dark:text-slate-400">None</p>
        ) : (
          <div className="flex flex-wrap gap-2">
            {report.missingKeywords.map((kw, i) => (
              <span key={i} className="px-2 py-1 bg-rose-50 dark:bg-rose-500/10 text-rose-700 dark:text-rose-400 border border-rose-200 dark:border-rose-500/20 text-xs font-semibold uppercase tracking-wider rounded">
                {kw}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
